import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function BodyPeopleCompanies() {
    return (
        <OnboardingBody
            title={
                <span>
                    We’re almost there… <br /> Just four things you should know
                </span>
            }
        >
            <div>
                <p>
                    In Nutshell, you track <strong>people</strong> and <strong>companies</strong>
                    —whether it’s your best customer or somebody
                    <br /> you just met at a conference.
                </p>
            </div>
        </OnboardingBody>
    );
}
